import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import ContentWrapper from "../../components/Common/ContentWrapper";
import Grid from "../../components/Grid";
import { Show } from "../../hooks/Show";

import { addressRoadTypeActions } from "../../redux/reducers/addressRoadTypeReducer";

const AddressRoadType = ({
  requestStatus,
  reduxResetAddressRoadTypeForm,
  reduxPatchAddressRoadType,
  reduxPostAddressRoadType,
  reduxDeleteAddressRoadType,
  reduxGetAddressRoadType,
  addressRoadTypes,
  reduxGetAddressRoadTypes,
  addressRoadType,
  rowEdited,
  rowDeleted,
  rowUpdated,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [offset, setOffset] = useState(10);
  const columns = [
    {
      title: "#",
      render: (rowData) => {
        return <span>{rowData.idAddressRoadType}</span>;
      },
      field: 'idAddressRoadType',
      searchable: true
    },
    {
      title: "Código",
      render: (rowData) => {
        return <span>{rowData.code}</span>;
      },
      field: 'code',
      searchable: true
    },
    {
      title: "Descripción",
      render: (rowData) => {
        return <span>{rowData.name}</span>;
      },
      field: 'name',
      searchable: true
    },
    {
      title: "Opciones",
      render: (rowData) => {
        return (
          <>
            {rowData.isActive ? (
              <>
                <Show when="feature:edit-addressRoadType">
                  <button
                    title="Editar"
                    className="btn btn-primary btn-sm  btn-circle mr-2"
                    type="button"
                    onClick={(e) => handleOpen(rowData)}
                  >
                    <i className="fas fa-edit fa-xs"></i>
                  </button>
                </Show>
                <Show when="feature:disabled-addressRoadType">
                  <button
                    title="Desactivar"
                    className="btn btn-danger btn-sm btn-circle"
                    type="button"
                    onClick={(e) => handleDelete(rowData)}
                  >
                    <i className="fas fa-times-circle fa-xs"></i>
                  </button>
                </Show>
              </>
            ) : (
              <Show when="feature:enabled-addressRoadType">
                <button
                  title="Activar"
                  className="btn btn-primary btn-sm  btn-circle mr-2"
                  type="button"
                  onClick={(e) => handleActive(rowData)}
                >
                  <i className="fas fa-check-circle fa-xs"></i>
                </button>
              </Show>
            )}
          </>
        );
      },
    },
  ];
  const handleClose = () => {
    reduxResetAddressRoadTypeForm();
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const onSubmit = (data) => {
    if (rowEdited) {
      reduxPatchAddressRoadType({ ...data, id: rowEdited.idAddressRoadType });
    } else {
      reduxPostAddressRoadType({ ...data, id: data.name, code: data.name });
    }
    reset();
    reduxResetAddressRoadTypeForm();
    setShow(false);
  };
  const handleOpen = (row) => {
    reduxGetAddressRoadType({
      id: row.idAddressRoadType,
    });
  };

  const handleActive = (row) => {
    if (!row.isActive) {
      reduxDeleteAddressRoadType(row);
    }
  };

  const handleDelete = (row) => {
    reduxDeleteAddressRoadType(row);
  };
  useEffect(() => {
    reduxGetAddressRoadTypes({
      page: 1,
      offset: offset,
      search: "",
    });
  }, []);

  useEffect(() => {
    if (rowEdited) {
      setShow(true);
      setValue("name", rowEdited.name);
      setValue("code", rowEdited.code);
    }
  }, [rowEdited]);

  useEffect(() => {
    reduxGetAddressRoadTypes({
      page: currentPage,
      offset: offset,
      search: search,
    });
  }, [currentPage]);

  useEffect(() => {
    if (addressRoadType || rowUpdated || rowDeleted) {
      reduxGetAddressRoadTypes({
        page: currentPage,
        offset: offset,
        search: search,
      });
      reduxResetAddressRoadTypeForm();
    }
  }, [addressRoadType, rowUpdated, rowDeleted]);

  return (
    <ContentWrapper>
      <div className="d-sm-flex align-items-center mb-1">
        <h1 className="h3 mb-0 text-gray-800 mr-3">Indicativos de Vía</h1>
        <Show when="feature:create-addressRoadType">
          <button
            className="btn btn-primary btn-circle"
            type="button"
            onClick={handleShow}
          >
            <i className="fas fa-plus fa-sm"></i>
          </button>
        </Show>
      </div>
      <p className="mb-4">Indicativos</p>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Listado de Indicativos de Vía
          </h6>
        </div>
        <div className="card-body">
          <Grid
            cols={columns}
            data={
              addressRoadTypes && Object.keys(addressRoadTypes).length > 0
                ? addressRoadTypes.items
                : []
            }
            page={
              addressRoadTypes && Object.keys(addressRoadTypes).length > 0
                ? Number(addressRoadTypes.page)
                : currentPage
            }
            pages={
              addressRoadTypes && Object.keys(addressRoadTypes).length > 0
                ? Number(addressRoadTypes.totalPages)
                : 1
            }
            total={
              addressRoadTypes && addressRoadTypes.hasOwnProperty("total")
                ? addressRoadTypes.total
                : 0
            }
            offset={offset}
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRange={(value) => {
              setOffset(value);
              reduxGetAddressRoadTypes({
                page: 1,
                offset: value,
                search: search,
              });
            }}
            defaultValue={search}
            onChangeSearch={(value) => {
              setSearch(value);
              reduxGetAddressRoadTypes({
                page: 1,
                offset: offset,
                search: value,
              });
            }}
          />
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        onEscapeKeyDown={handleClose}
        backdrop="static"
        keyboard={true}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>
              {rowEdited ? "Editar" : "Nuevo"} Indicativo de Vía
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label htmlFor="code" className="form-label">
                Código
              </label>
              <input
                id="code"
                type="text"
                className={`form-control form-control-user ${
                  errors.code && "is-invalid"
                }`}
                {...register("code", { required: true })}
              />
              {errors.code && (
                <span className="invalid-feedback">El código es requerido</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                Descripción
              </label>
              <input
                id="name"
                type="text"
                className={`form-control form-control-user ${
                  errors.name && "is-invalid"
                }`}
                {...register("name", { required: true })}
              />
              {errors.name && (
                <span className="invalid-feedback">
                  La Descripción requerida
                </span>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </ContentWrapper>
  );
};

const mapStateToProps = (state) => ({
  addressRoadTypes: state.addressRoadType.addressRoadTypes,
  addressRoadType: state.addressRoadType.addressRoadType,
  rowEdited: state.addressRoadType.rowEdited,
  rowDeleted: state.addressRoadType.rowDeleted,
  rowUpdated: state.addressRoadType.rowUpdated,
});

const mapDispatchToProps = (dispatch) => ({
  reduxGetAddressRoadTypes: (payload) =>
    dispatch({
      type: addressRoadTypeActions.FETCH_ADDRESSROADTYPE_REQUEST,
      value: payload,
    }),
  reduxPostAddressRoadType: (payload) =>
    dispatch({
      type: addressRoadTypeActions.CREATE_ADDRESSROADTYPE_REQUEST,
      value: payload,
    }),
  reduxGetAddressRoadType: (payload) =>
    dispatch({
      type: addressRoadTypeActions.READ_ADDRESSROADTYPE_REQUEST,
      value: payload,
    }),
  reduxDeleteAddressRoadType: (payload) =>
    dispatch({
      type: addressRoadTypeActions.DELETE_ADDRESSROADTYPE_REQUEST,
      value: payload,
    }),
  reduxPatchAddressRoadType: (payload) =>
    dispatch({
      type: addressRoadTypeActions.UPDATE_ADDRESSROADTYPE_REQUEST,
      value: payload,
    }),
  reduxResetAddressRoadTypeForm: () =>
    dispatch({
      type: addressRoadTypeActions.RESET_ADDRESSROADTYPE_FORM,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressRoadType);
